export enum ProcessStatusType {
  SUCCESS = 'success',
  FAILURE = 'failure',
  TIMEOUT = 'timeout',
  IN_DEVELOPMENT = 'in-development',
  NOT_FOUND = 'not-found',
}
